// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDx8ArrXwvxuLkIKScm31SxnhkXRXubeOI",
  authDomain: "eosyesbot-f2ec2.firebaseapp.com",
  projectId: "eosyesbot-f2ec2",
  storageBucket: "eosyesbot-f2ec2.firebasestorage.app",
  messagingSenderId: "1049075599545",
  appId: "1:1049075599545:web:267b2228f76a609a14b368",
  measurementId: "G-R6NGXGYS1C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, db, auth, storage };